<template>
    <Splide
        v-if="props.projects.length"
        :options="splideOptions"
        style="perspective: 1000px">
        <SplideSlide
            v-for="project in props.projects"
            :key="project.documentId">
            <div
                class="project-card-scene"
                @click="clickSlide(project.documentId)"
                @mouseenter="clickSlide(project.documentId)"
                @mouseleave="clickSlide(null)">
                <div
                    class="project-card tw-relative xs:tw-aspect-square tw-rounded-4xl max-xs:tw-h-[410px]"
                    :class="{
                        'has-description': !!project.description,
                        'tw-cursor-pointer': !!project.description,
                        'is-clicked': rotatedSlide === project.documentId,
                    }">
                    <div
                        class="project-card-front tw-absolute tw-inset-0 tw-z-20 max-xs:tw-h-[410px] xs:tw-aspect-square tw-rounded-4xl tw-bg-cover tw-bg-center tw-bg-no-repeat"
                        :class="{
                            'tw-bg-white': !project.image,
                        }"
                        :style="{ backgroundImage: project.image ? `url(${useMedia(project.image).medium})` : '' }">
                        <div
                            class="tw-relative tw-z-[1] tw-flex tw-h-full tw-w-full tw-flex-col tw-justify-end tw-gap-2 tw-overflow-hidden tw-rounded-4xl tw-border tw-border-solid tw-border-gray tw-px-8 tw-py-7 tw-text-white before:tw-absolute before:tw-inset-0 before:tw-z-[-1] before:tw-bg-gradient-to-t before:tw-from-black before:tw-to-transparent before:tw-opacity-70">
                            <div>
                                <span
                                    v-for="(tag, k) in project.tags"
                                    :key="tag.documentId"
                                    class="tw-mr-1 max-md:tw-text-sm"
                                    >{{ tag.name }}{{ k == project.tags.length - 1 ? '' : ',' }}</span
                                >
                            </div>
                            <h3>{{ project.name }}</h3>
                        </div>
                    </div>
                    <div class="project-card-back tw-absolute tw-inset-0 tw-z-10 tw-rounded-4xl tw-border tw-border-solid tw-border-gray tw-bg-white tw-px-6 tw-py-6">
                        <p
                            class="sm:max-md:tw-text-[11px] sm:max-md:tw-leading-4 lg:max-xl:tw-text-xs tw-text-sm"
                            v-html="project.description"></p>
                    </div>
                </div>
            </div>
        </SplideSlide>
    </Splide>
</template>

<script setup lang="ts">
    import { useMedia } from '@/composables/useMedia';
    import { Splide, SplideSlide } from '@splidejs/vue-splide';

    const rotatedSlide = ref<null | string>(null);

    const props = defineProps<{
        projects: {
            id: number;
            documentId: string;
            name: string;
            tags: {
                id: number;
                documentId: string;
                name: string;
            }[];
            image: any;
        }[];
    }>();

    function clickSlide(documentId: string) {
        if (rotatedSlide.value === documentId) {
            rotatedSlide.value = null;
        } else {
            rotatedSlide.value = documentId;
        }
    }

    const splideOptions = ref({
        type: 'slide',
        perPage: 4,
        perMove: 1,
        gap: '3rem',
        pagination: false,
        arrows: props.projects.length > 4,
        autoplay: props.projects.length > 4,
        interval: 2000,
        rewind: true,
        breakpoints: {
            1792: {
                perPage: 3,
                arrows: props.projects.length > 3,
                autoplay: props.projects.length > 3,
                // autoplay: false,
                gap: '2rem',
            },
            1024: {
                perPage: 2,
                arrows: props.projects.length > 2,
                autoplay: props.projects.length > 2,
                gap: '1rem',
            },
            640: {
                perPage: 1,
                arrows: props.projects.length > 1,
                autoplay: props.projects.length > 1,
                gap: '1rem',
            },
        },
    });
</script>

<style scoped lang="scss">
    .project-card {
        transform-style: preserve-3d;
        transition: transform 0.6s;
        outline: none;
    }

    .project-card-front,
    .project-card-back {
        backface-visibility: hidden; /* hide the back when flipped */
        -webkit-backface-visibility: hidden;
        pointer-events: none;
    }

    .project-card-back {
        transform: rotateY(180deg);
    }

    .project-card-scene {
        perspective: 1000px;
        overflow: visible !important;
        padding-block: 2rem;
    }

    .project-card.has-description.is-clicked {
        transform: rotateY(180deg);
        /* overflow: auto; */
    }
</style>
<style></style>
